<div matDialogTitle i18n>Terms and Conditions</div>
<mat-dialog-content #scrollContainer (scroll)="onScroll($event)">
    <h3>{{ term.name }}</h3>
    <div [innerHTML]="sanitizedText"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="decline()" i18n>Decline</button>
    <button mat-button color="primary" (click)="accept()" [disabled]="!hasScrolledToEnd" i18n>Accept</button>
</mat-dialog-actions>
